// extracted by mini-css-extract-plugin
export default {"diagnosticIcon":"DiagnosticIcon_diagnosticIcon__E2mEj","error":"DiagnosticIcon_error__JHQ5C","warning":"DiagnosticIcon_warning__Ervna","info":"DiagnosticIcon_info__sC8NG"};